import { render, staticRenderFns } from "./RoleRibbon.vue?vue&type=template&id=63fed192&scoped=true"
import script from "./RoleRibbon.vue?vue&type=script&lang=ts"
export * from "./RoleRibbon.vue?vue&type=script&lang=ts"
import style0 from "./RoleRibbon.vue?vue&type=style&index=0&id=63fed192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fed192",
  null
  
)

export default component.exports